<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-apps</v-icon>{{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <SoftwareForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import SoftwareForm from '../../components/software/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'Software';

export default {
  name: 'SoftwareUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    SoftwareForm
  },

  computed: {
    ...mapFields('software', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('software', ['find'])

  },

  methods: {
    ...mapActions('software', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
